"use client";

const styles = new Proxy({"BlogTeaser":"BlogTeaser-f2761","Title":"Title-f2761","Subtitle":"Subtitle-f2761","PostsRow":"PostsRow-f2761","CarouselWrap":"CarouselWrap-f2761","SlideOuter":"SlideOuter-f2761","col-lg-4":"col-lg-4-f2761","Controls":"Controls-f2761","Dots":"Dots-f2761","Dot":"Dot-f2761","DotActive":"DotActive-f2761","ArrowBtn":"ArrowBtn-f2761","CTA":"CTA-f2761"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import PostCard from "./PostCard/index";
import BlogTeaserCarousel from "./BlogTeaserCarousel";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { Tag } from "@/themes/ci/blog/types";
import { Post } from "./types";

export default function BlogTeaserComponent({
  block,
}: {
  block: BlogTeaserComponentProps;
}) {
  const { posts: inputPosts, title, btnLabel, style } = block;
  const posts = inputPosts.length ? inputPosts : [];
  const router = useRouter();

  return (
    <section id="BlogTeaser" className={styles.BlogTeaser} style={style}>
      <div className="container">
        <h2 className={styles.Title}>{title ?? "Recent blog posts"}</h2>
        <p className={styles.Subtitle}>
          Learn more about our technology. Join the discussion.
        </p>

        <div className={`row ${styles.PostsRow}`}>
          {posts.map((post, index) => (
            <PostCard
              key={post.id}
              post={post}
              className="px-3"
              router={router}
              isFirst={index === 0}
            />
          ))}
        </div>

        <BlogTeaserCarousel posts={posts} />

        <div className="row text-center mt-4">
          <div className="col-12">
            <Link href="/blog" className={styles.CTA}>
              {btnLabel ?? "Book a demo"}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

type BlogTeaserComponentProps = {
  posts: Post[];
  title?: string;
  btnLabel?: string;
  style?: React.CSSProperties;
};
